export default "__VITE_ASSET__CwHwK36J__"